export default __webpack_public_path__ + "static/media/communityPowered.27dc6e8f.png";